var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeChat = function SvgEyeChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 512 512"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eye-chat_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 508.031,
    height: 508.031,
    x: 1.984,
    y: 1.984,
    fill: "url(#eye-chat_svg__b)",
    rx: 254.016
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eye-chat_svg__c)",
    d: "M256.129 509.81c140.289 0 254.015-113.726 254.015-254.015S396.418 1.779 256.129 1.779 2.113 115.506 2.113 255.795 115.84 509.81 256.13 509.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m346.253 119.813-55.268 391.184-119.624 1.966zm-.002 0L97.725 294.007h108.174l-22.241 159.16z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "eye-chat_svg__b",
    x1: 615.365,
    x2: 92.633,
    y1: -115.545,
    y2: 485.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DFADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#418BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eye-chat_svg__c",
    x1: 615.494,
    x2: 92.762,
    y1: -115.75,
    y2: 485.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DFADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#418BFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eye-chat_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 508.031,
    height: 508.031,
    x: 1.984,
    y: 1.984,
    fill: "#fff",
    rx: 254.016
  })))));
};
export default SvgEyeChat;